// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app-switcher-btn[data-v-989746d0]{background-color:#002925!important}#app-list[data-v-989746d0]{margin-top:6px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
